import { createApp } from '@wu/widget-core';
import { ClickToCall } from './ClickToCall';
import { meta } from './meta';

const { alias, name } = meta;

export default createApp({ alias, name }, ClickToCall);
